import {Box} from '@mui/material';
import './ProcessingSyncPage.scss';
import ProcessingSyncHeader from './ProcessingSyncHeader';
import ProcessingSyncDetailsPanel from './ProcessingSyncDetailsPanel';
import ProcessingSyncSummaryPanel from './ProcessingSyncSummaryPanel';

export const TEST_IDS = {
  PAGE: 'processing-sync-page',
  CONTENT: 'processing-sync-content',
} as const;

const ProcessingSyncPage = () => {
  const handleSummaryRefresh = () => {};

  const handleErrorsRefresh = () => {};

  return (
    <Box className="processing-sync-page" data-testid={TEST_IDS.PAGE}>
      <ProcessingSyncHeader />
      <Box className="processing-sync-content" data-testid={TEST_IDS.CONTENT}>
        <ProcessingSyncSummaryPanel onRefresh={handleSummaryRefresh} />
        <ProcessingSyncDetailsPanel onRefresh={handleErrorsRefresh} />
      </Box>
    </Box>
  );
};

export default ProcessingSyncPage;
